var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sale-banner" },
    [
      !_vm.sale.video_description.length
        ? _c("div", [
            _c("div", { staticClass: "text_large" }, [
              _vm._v(_vm._s(_vm.i18n.sale_video_empty_header()))
            ])
          ])
        : _vm._l(_vm.embedVideoUrls, function(url, index) {
            return _c(
              "div",
              { key: index, staticClass: "sale-banner__video" },
              [
                _c(
                  "md-card",
                  [
                    _c("md-card-media", [
                      _c("iframe", {
                        staticStyle: { width: "100%", height: "100%" },
                        attrs: {
                          src: url,
                          frameborder: "0",
                          allow:
                            "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                          allowfullscreen: ""
                        }
                      })
                    ])
                  ],
                  1
                )
              ],
              1
            )
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-96b16596", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96b16596","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/sales/sale_details/components/Sales.Banner.vue
// module id = 3wSJ
// module chunks = 1